(() => {
  const getSelectedAccessories = (productInfo) =>
    [...productInfo.querySelectorAll('[data-or-kit-accessory]:checked:not(:disabled)')]
      .map((input) => input.value)
      .filter(Boolean);

  const getCartErrorMessage = (state) => {
    if (state?.description) return state.description;
    if (state?.message) return state.message;
    if (state?.errors) {
      if (typeof state.errors === 'string') return state.errors;
      const firstError = Object.values(state.errors).flat().filter(Boolean)[0];
      if (firstError) return firstError;
    }
    return 'No se pudo agregar al carrito. Revisa stock o variantes disponibles.';
  };

  const getSections = () => {
    if (document.querySelector('cart-drawer')) return 'cart-drawer,cart-icon-bubble';
    if (document.querySelector('cart-notification')) return 'cart-notification-product,cart-notification-button,cart-icon-bubble';
    return 'cart-icon-bubble';
  };

  const getSectionInnerHTML = (html, selector = '.shopify-section') => {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || null;
  };

  const getBundlePayload = (form, productInfo, includeSections = true) => {
    const accessoryIds = getSelectedAccessories(productInfo);
    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = productInfo.querySelector('.product-form__quantity [name="quantity"]');
    const mainVariantId = variantInput?.value;
    const quantity = Number(quantityInput?.value) || 1;

    if (!mainVariantId || !accessoryIds.length) return null;

    const body = {
      items: [{ id: mainVariantId, quantity }, ...accessoryIds.map((id) => ({ id, quantity: 1 }))],
    };

    if (includeSections) {
      body.sections = getSections();
      body.sections_url = window.location.pathname;
    }

    return body;
  };

  const addBundleToCart = async (body) => {
    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    const state = await response.json();
    if (!response.ok) throw new Error(getCartErrorMessage(state));
    return state;
  };

  const clearCart = async () => {
    const response = await fetch(window.routes?.cart_clear_url || '/cart/clear.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      const state = await response.json();
      throw new Error(getCartErrorMessage(state));
    }
  };

  const showCartError = (form, error) => {
    const errorWrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = error.message;
      errorWrapper.removeAttribute('hidden');
      return;
    }

    window.location.href = window.routes?.cart_url || '/cart';
  };

  const renderCart = (state, submitButton) => {
    if (!state.sections) {
      window.location.href = window.routes?.cart_url || '/cart';
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const drawerHTML = getSectionInnerHTML(state.sections['cart-drawer'], '#CartDrawer');
      const bubbleHTML = getSectionInnerHTML(state.sections['cart-icon-bubble']);
      const drawer = cartDrawer.querySelector('#CartDrawer');
      const bubble = document.getElementById('cart-icon-bubble');

      if (drawerHTML && drawer) drawer.innerHTML = drawerHTML;
      if (bubbleHTML && bubble) bubble.innerHTML = bubbleHTML;

      if (drawerHTML && cartDrawer.open) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.open(submitButton);
        return;
      }
    }

    const bubbleHTML = getSectionInnerHTML(state.sections['cart-icon-bubble']);
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHTML && bubble) {
      bubble.innerHTML = bubbleHTML;
    }

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification?.renderContents && state.key) {
      cartNotification.setActiveElement(submitButton);
      cartNotification.renderContents(state);
      return;
    }

    if (bubbleHTML) {
      return;
    }

    window.location.href = window.routes?.cart_url || '/cart';
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      const productInfo = form.closest('product-info');
      if (!productInfo) return;

      const accessoryIds = getSelectedAccessories(productInfo);
      if (!accessoryIds.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[type="submit"]');
      const submitText = submitButton?.querySelector('span');
      const body = getBundlePayload(form, productInfo);

      if (!body || submitButton?.disabled) return;

      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      if (submitText) submitText.classList.add('hidden');

      try {
        const state = await addBundleToCart(body);
        productInfo.querySelectorAll('[data-or-kit-accessory]:checked').forEach((input) => {
          input.checked = false;
        });
        renderCart(state, submitButton);
      } catch (error) {
        showCartError(form, error);
      } finally {
        submitButton?.removeAttribute('aria-disabled');
        submitButton?.classList.remove('loading');
        if (submitText) submitText.classList.remove('hidden');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    async (event) => {
      const buyNowButton = event.target.closest('.shopify-payment-button__button');
      if (!buyNowButton) return;

      const productForm = buyNowButton.closest('product-form');
      const form = productForm?.querySelector('form[data-type="add-to-cart-form"]');
      const productInfo = buyNowButton.closest('product-info');
      if (!form || !productInfo) return;

      const body = getBundlePayload(form, productInfo, false);
      if (!body) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      buyNowButton.setAttribute('aria-disabled', 'true');
      buyNowButton.classList.add('loading');

      try {
        await clearCart();
        await addBundleToCart(body);
        window.location.href = `${window.routes?.root_url || '/'}checkout`;
      } catch (error) {
        showCartError(form, error);
        buyNowButton.removeAttribute('aria-disabled');
        buyNowButton.classList.remove('loading');
      }
    },
    true
  );
})();
